import styled from 'styled-components';
import { forceBreakTextCss, SectionContainer, sectionContainerCss, } from '../styles';
export const CatalogSectionContainer = styled(SectionContainer) `
    padding-left: 0;
    padding-right: 0;

    .title {
        ${sectionContainerCss}
        padding-top: 0;
        padding-bottom: 0;
    }

    .navigation-section {
        display: flex;
        margin-top: 32px;

        justify-content: ${(props) => props.theme.align.toLowerCase()};

        > div:first-child {
            margin-right: 16px;
            margin-left: 32px;
        }

        @media (max-width: 480px) {
            display: none;
        }
    }
`;
export const Cards = styled.div `
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    .card {
        cursor: pointer;
        min-width: 272px;
        margin-right: 16px;

        &.full-width {
            width: 100%;
            margin-right: 32px;
        }

        &:first-child {
            margin-left: 32px;
        }

        &:last-child {
            position: relative;
            &::after {
                position: absolute;
                content: '';
                right: -32px;
                width: 32px;
                height: 1px;
            }
        }

        > .info {
            ${forceBreakTextCss};
            height: 196px;
            padding: 24px;
            background-color: ${(props) => props.theme.cardColor};
            color: ${({ theme }) => theme.cardText};
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;

            h5,
            p {
                margin-bottom: 8px;
            }

            display: flex;
            flex-direction: column;
            justify-content: space-between;

            h6 {
                display: inline-block;
                border-bottom: 1px solid;
                padding-bottom: 8px;
            }
        }
    }
`;
export const CardImage = styled.div `
    background-color: ${({ theme }) => theme.cardColor};
    background-image: url(${(props) => props.$image});
    height: 204px;
    background-size: cover;
    background-position: center;
    border-radius: 8px 8px 0px 0px;

    -webkit-border-radius: 8px 8px 0px 0px;
`;
export const CircleNavigationButton = styled.div `
    width: 32px;
    height: 32px;
    border: 2px solid ${({ theme }) => theme.secondary};
    box-sizing: border-box;
    cursor: pointer;

    justify-content: center;
    align-items: center;
    border-radius: 100%;
    text-align: center;
    display: flex;

    &.disabled {
        opacity: 0.4;
        cursor: unset;
    }
`;
